<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default  {
  name:  'App',
  created(){
    // sessionStorage.setItem('hostName',document.location.hostname)
  }
}
</script>

<style lang="scss">
:root{
  --app-font-size-xs: 12px;
  --app-font-size-sm: 13px;
  --app-font-size-base: 14px;
  --app-font-size-md: 16px;
  --app-font-size-lg: 18px;
  --app-line-height-base: 1.5;
  --app-space-1: 4px;
  --app-space-2: 8px;
  --app-space-3: 12px;
  --app-space-4: 16px;
  --app-space-5: 20px;
  --app-space-6: 24px;
  --app-page-gutter: 5px;
  --app-card-padding: 10px;
  --app-radius-base: 4px;
  --app-border-color: #ebeef5;
  --app-bg-soft: #E9ECF0;
  --app-text-primary: #303133;
  --app-text-regular: #606266;
  --app-text-secondary: #909399;
}

#app{
  width: 100%;
  height: 100%;
}
* {
  box-sizing: border-box
}
body {
  min-width: 1200px;
}
@import './common/scss/common.scss';
@import './common/scss/alibaba_iconfont_config.scss';
@import './common/theme/index.scss';
</style>




// WEBPACK FOOTER //
// src/App.vue